import { createCtx } from '@shared/util/context';
import { type Batch } from './batchContextTypes';

export const [useBatch, BatchProvider] = createCtx<Batch>();
